import {
  type BankType,
  type GetOfferCodeDataResponse,
  type ValidateOfferCodeRequest,
  type ValidateOfferCodeResponse,
} from '@sparrow-card/sparrow-card-constants';
import Api, { FetchMethodType } from 'api/Api';
import { getBrowserInfo } from 'utils/browserInfo';

export interface PrepopulatedDataResponse {
  firstName: string;
  middleInitial?: string;
  lastName: string;
  dateOfBirth: string;
  streetAddress: string;
  unit?: string;
  city: string;
  state: string;
  zipCode: string;
  loanAmount?: number;
  bankPartner?: BankType;
}

export default class OfferCodeApi extends Api {
  public async getPrepopulatedData(
    offerCode: string,
    zipCode: string,
  ): Promise<PrepopulatedDataResponse> {
    return this.fetch<PrepopulatedDataResponse>(
      `/offer-code/pre-populated-data/${offerCode}/${zipCode}`,
      {
        method: FetchMethodType.GET,
      },
    );
  }

  public async validateOfferCode(
    data: ValidateOfferCodeRequest,
  ): Promise<ValidateOfferCodeResponse> {
    return this.fetch<ValidateOfferCodeResponse>('/offer-code/validate', {
      method: FetchMethodType.POST,
      body: {
        offerCode: data.offerCode,
        zipCode: data.zipCode,
        ...('userId' in data && { userId: data.userId }),
        browserInfo: getBrowserInfo(),
      },
    });
  }

  public async getOfferCodeDataByUserId(userId: string): Promise<GetOfferCodeDataResponse> {
    return this.fetch<GetOfferCodeDataResponse>(`/offer-code/offer-data/${userId}/`, {
      method: FetchMethodType.GET,
    });
  }
}
